import axios from "axios";
import {SearchServerUrl} from "../../../../Settings";

const searchEndpoint = axios.create({
   baseURL: SearchServerUrl
})

export type SearchResult = SearchProduct[]

export interface SearchProduct {
   id: string
   styleId: string
   name: string
   color: string
   image: string
   rrp: number
   tradeInValue: number
   ruleId?: string
   sizes: SearchProductSize[]
}

export interface SearchProductSize {
   id: string
   size: string
   sku: string
   ean?: string
}

export const searchProduct = async (brandHouseId: string, shopId: string, search: string, language: string, currency?: string) => {
   try {
      const response = await searchEndpoint.get('/' + brandHouseId, {
         params: {
            s: search,
            language: language,
            shopId: shopId,
            currency: currency
         }
      });
      return response.data as SearchResult
   } catch (error) {
      return []
   }
}
